import _EmbedBlock from "./embed-block.component.js";
import _FileGrid from "./file-grid.component.js";
import _BigFile from "./big-file.component.js";
import _MiniFile from "./mini-file.component.js";

export const EmbedBlock = _EmbedBlock;
export const FileGrid = _FileGrid;
export const BigFile = _BigFile;
export const MiniFile = _MiniFile;
